var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"flex-row middle-xs"},[_c('strong',{staticClass:"col-xs-6"},[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(" "),_c('strong',{staticClass:"col-xs-6 end-xs"},[_vm._v("\n            "+_vm._s(_vm._f("dinheiro")(_vm.value))+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e3d1d2d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TotalSimulador.vue
// module id = null
// module chunks = 